var niedersachsenQuestions = [
  {
    id: '301',
    question: 'Welches Wappen gehört zum Bundesland Niedersachsen?',
    image: '381',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 1,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Niedersachsen',
  },
  {
    id: '302',
    question: 'Welches ist ein Landkreis in Niedersachsen?',
    answers: [
      {
        content: 'Ammerland',
        key: 1,
      },
      {
        content: 'Rhein-Sieg-Kreis',
        key: 0,
      },
      {
        content: 'Nordfriesland',
        key: 0,
      },
      {
        content: 'Vogtlandkreis',
        key: 0,
      },
    ],
    category: 'Niedersachsen',
  },
  {
    id: '303',
    question: 'Für wie viele Jahre wird der Landtag in Niedersachsen gewählt?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
      {
        content: '5',
        key: 1,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Niedersachsen',
  },
  {
    id: '304',
    question: 'Ab welchem Alter darf man in Niedersachsen bei Kommunalwahlen wählen?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '16',
        key: 1,
      },
      {
        content: '18',
        key: 0,
      },
      {
        content: '20',
        key: 0,
      },
    ],
    category: 'Niedersachsen',
  },
  {
    id: '305',
    question: 'Welche Farben hat die Landesflagge von Niedersachsen?',
    answers: [
      {
        content: 'rot-weiß',
        key: 0,
      },
      {
        content: 'schwarz-rot-gold',
        key: 1,
      },
      {
        content: 'schwarz-gelb',
        key: 0,
      },
      {
        content: 'blau-weiß-rot',
        key: 0,
      },
    ],
    category: 'Niedersachsen',
  },
  {
    id: '306',
    question: 'Wo können Sie sich in Niedersachsen über politische Themen informieren?',
    answers: [
      {
        content: 'beim Koordinator für politische Bildung im Kultusministerium',
        key: 1,
      },
      {
        content: 'beim Ordnungsamt der Gemeinde',
        key: 0,
      },
      {
        content: 'bei der Verbraucherzentrale',
        key: 0,
      },
      {
        content: 'bei den Kirchen',
        key: 0,
      },
    ],
    category: 'Niedersachsen',
  },
  {
    id: '307',
    question: 'Die Landeshauptstadt von Niedersachsen heißt...',
    answers: [
      {
        content: 'Hannover.',
        key: 1,
      },
      {
        content: 'Braunschweig.',
        key: 0,
      },
      {
        content: 'Wolfsburg.',
        key: 0,
      },
      {
        content: 'Osnabrück.',
        key: 0,
      },
    ],
    category: 'Niedersachsen',
  },
  {
    id: '308',
    question: 'Welches Bundesland ist Niedersachsen?',
    image: '388',
    answers: [
      {
        content: '1',
        key: 1,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Niedersachsen',
  },
  {
    id: '309',
    question: 'Wie nennt man den Regierungschef / die Regierungschefin in Niedersachsen?',
    answers: [
      {
        content: 'Erster Minister / Erste Ministerin',
        key: 0,
      },
      {
        content: 'Premierminister / Premierministerin',
        key: 0,
      },
      {
        content: 'Bürgermeister / Bürgermeisterin',
        key: 0,
      },
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 1,
      },
    ],
    category: 'Niedersachsen',
  },
  {
    id: '310',
    question: 'Welchen Minister / welche Ministerin hat Niedersachsen nicht?',
    answers: [
      {
        content: 'Justizminister / Justizministerin',
        key: 0,
      },
      {
        content: 'Außenminister / Außenministerin',
        key: 1,
      },
      {
        content: 'Finanzminister / Finanzministerin',
        key: 0,
      },
      {
        content: 'Innenminister / Innenministerin',
        key: 0,
      },
    ],
    category: 'Niedersachsen',
  },
]

export default niedersachsenQuestions
